import { getCampaignList, getEmailCampaignAnalytics, getEmailCampaignDetailedReport } from "../types/account_campaign_types";


export const getCampaignListRequest = (payload) => ({
    type: getCampaignList.GET_CAMPAIGN_LIST_REQUEST,
    payload,
});
export const getCampaignListRequestAfter = (payload) => ({
    type: getCampaignList.GET_CAMPAIGN_LIST_REQUEST_AFTER,
    payload,
});
export const getCampaignListSuccess = (payload) => ({
    type: getCampaignList.GET_CAMPAIGN_LIST_SUCCESS,
    payload,
});
export const getCampaignListError = (payload) => ({
    type: getCampaignList.GET_CAMPAIGN_LIST_ERROR,
    payload,
});

export const getEmailCampaignAnalyticsRequest = (payload) => ({
    type: getEmailCampaignAnalytics.GET_EMAIL_CAMPAIGN_ANALYTICS_REQUEST,
    payload,
});
export const getEmailCampaignAnalyticsSuccess = (payload) => ({
    type: getEmailCampaignAnalytics.GET_EMAIL_CAMPAIGN_ANALYTICS_SUCCESS,
    payload,
});
export const getEmailCampaignAnalyticsError = (payload) => ({
    type: getEmailCampaignAnalytics.GET_EMAIL_CAMPAIGN_ANALYTICS_ERROR,
    payload,
});

export const getEmailCampaignDetailedReportRequest = (payload, cb) => ({
    type: getEmailCampaignDetailedReport.GET_EMAIL_CAMPAIGN_DETAILED_REPORT_REQUEST,
    payload,
    cb,
});
export const getEmailCampaignDetailedReportSuccess = (payload) => ({
    type: getEmailCampaignDetailedReport.GET_EMAIL_CAMPAIGN_DETAILED_REPORT_SUCCESS,
    payload,
});
export const getEmailCampaignDetailedReportError = (payload) => ({
    type: getEmailCampaignDetailedReport.GET_EMAIL_CAMPAIGN_DETAILED_REPORT_ERROR,
    payload,
});